import { render } from "./README.md?vue&type=template&id=778a8d1c"
import script from "./README.md?vue&type=script&lang=js"
export * from "./README.md?vue&type=script&lang=js"
script.render = render

export default script